
import FilterBase from "./filterBase.js";

export default class Colorize extends FilterBase {
    objectType = "ColorizeFilterItem";
    _Color = "rgba(0, 0, 0, 1)";
    _Intensity = 20;

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        if (args.tooltip == null) {
            args.tooltip = "Colorie l'image en fonction du paramètre";
        }
        super.objectToClassValue(args);
        this._Color = args.color ? args.color : "rgba(255, 0, 0, 1)";
        this._Intensity = args.intensity ? args.intensity : 20;
    }

    get Color() {
        return this._Color;
    }
    set Color(value) {
        if (this._Color != value) {
            this.invalidateFilterCache();
            this._Color = value;
        }
    }

    get Intensity() {
        return this._Intensity;
    }
    set Intensity(value) {
        value = parseInt(value);
        if (value < 0) {
            value = 0;
        }
        if (value > 100) {
            value = 100;
        }
        if (this._Intensity != value) {
            this.invalidateFilterCache();
            this._Intensity = value;
        }
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { text: "Couleur", name: "Color", type: "colorInput", dataType: "string", noAlpha: true },
            { text: "Intensité", name: "Intensity", type: "rangeInput", min: 0, max: 100, step: 1, dataType: "number" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    static get Name() {
        return "Colorize";
    }

    async filterAction(cv, cvImage) {
        if (cvImage == null) {
            return cvImage;
        }

        let strength = this.Intensity / 100;
        
        // Convertir la couleur en format BGR pour OpenCV
        let color = this.colorStringToRgbaObject(this.Color);
        if (!color) {
            return cvImage;
        }

        try {
            // Créer l'overlay avec exactement le même type et nombre de canaux que l'image source
            let size = new cv.Size(cvImage.cols, cvImage.rows);
            let overlay = new cv.Mat(size, cvImage.type());

            
            // Remplir l'overlay avec la couleur cible
            // Adapter le scalaire selon le nombre de canaux
            let scalar;
            if (cvImage.channels() === 1) {
                // Image en niveaux de gris
                let gray = Math.round(0.299 * color.r + 0.587 * color.g + 0.114 * color.b);
                scalar = new cv.Scalar(gray);
            } else if (cvImage.channels() === 3) {
                // Image BGR (3 canaux)
                scalar = new cv.Scalar(color.r, color.g, color.b);
            } else if (cvImage.channels() === 4) {
                // Image BGRA (4 canaux)
                scalar = new cv.Scalar(color.r, color.g, color.b, 255);
            } else {
                // Par défaut, utiliser la première valeur
                scalar = new cv.Scalar(color.r);
            }
            
            overlay.setTo(scalar);

            // Appliquer le mélange linéaire
            cv.addWeighted(cvImage, 1.0 - strength, overlay, strength, 0.0, cvImage);

            // Nettoyer la mémoire
            overlay.delete();
        }
        catch (error) {
            console.error("Erreur dans le filtre colorize:", error);
            return cvImage;
        }
        return cvImage;
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Color", construct: String, jsType: "String" },
            { property: "Intensity", construct: Number, jsType: "Number" },
        ];
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            Color: this.rgbaStringToRgbString(this.Color),
            Intensity: this.Intensity,
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            color: this.Color,
            intensity: this.Intensity,
        };
    }
}